import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { AfWhitelist, AdaptedAfWhitelist } from 'data/afWhitelist/afWhitelist.types'

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  AfWhitelistData: AdaptedAfWhitelist,
  originaAfWhitelistFormData: AdaptedAfWhitelist | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.AF_WHITELIST_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.AF_WHITELIST_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(AfWhitelistData, null, isEdit, originaAfWhitelistFormData),
    AfWhitelistData.AFID,
    AuditService.AF_WHITELIST,
    actionType,
  );
  return auditDetails as AuditDetails;
}
